<zah-categorie-navigation [dienst]="dienst"
  [opened]="dienst.hasCategorieen()"
  (dienstenClicked)="onDienstenClicked()"
  (stopClicked)="onStopClicked()"
  (meldingenClicked)="onMeldingenClicked()"
  (signaalkaartenClicked)="onSignaalkaartenClicked()"
  (clientFicheClicked)="onClientFicheClicked()"
  (categorieSelected)="openCategory($event)">
  <div class="content">
    @if (!dienst.hasCategorieen()) {
      <div
        class="no-taken">
        Er zijn geen taken voor deze dienst. Contacteer je dienst.
      </div>
    }
    @if (dienst.hasCategorieen()) {
      <zah-prestatie-taken-select
        [prestatie]="prestatie"
        [taakGeschiedenis]="taakGeschiedenis"
        [dienst]="dienst"
        [category]="categorie"
        [taken]="taken"
        [taakTipAantallen]="taakTipAantallen"
        (taakSelected)="onTaakSelect($event)"
        (taakDeselected)="onTaakDeselect($event)"
        (tipsOpened)="onTipsOpened($event)">
      </zah-prestatie-taken-select>
    }
    <div class="fade-in"></div>
  </div>
</zah-categorie-navigation>
